import { PlaceType } from './place.type';

export class CalendarActionCommand {
  public queryCommand = new CalendarQueryCommand();
  public isEventCalendar = true;
  public isMapView = false;
}

export class CalendarQueryCommand {
  public page?: number = 0;
  public limit?: number = getRequestLimit(); //16;
  public from?: Date;
  public to?: Date;
  public category? = 'All';
  public categoryList?: string[]; // for custom default place categories
  public categoryNode?: PlaceType; // for custom default place categories
  public search?: string;
  public choice?: boolean;
  public favoriteEventBtnId?: string;
  public updateURL?: boolean; // first time landing to a custom favorite place/event page, it doesn't need to add the ig-custom-places/ig-custom-events query string to URL (as client may create a dedicated page for that)
  public type?: string; // custom favorite place id
  public source? = 'google';
  public isForMapView?: boolean;
  public isForSearchView?: boolean;
  public isForUpcoming?: boolean;
  public fromIndex?: number;
  public location?: string; // for location filter
  public locations?: string[]; // for location filter groups
  public hasFavoriteCategoryFromUrl?: boolean; // for favorite place categories
  public useFuzzyQuery?: boolean = true;
  public dateRange?: string; //like today, tomorrow, this-week, this-month
  public defaultSort?: string = undefined; // for default sort places
  public searchFields?: string = 'name'; // 'name', 'address', 'description', 'category',
  public loadedIds?: string[] = undefined; // for random sort places to load next random batch
  public alphabetically?: 'asc' | 'desc' = undefined; // for place letter order
}

export class HubCalendarActionCommand {
  public queryCommand = new HubCalendarQueryCommand();
  public isEventCalendar = true;
  public isMapView = false;
}

export class HubCalendarQueryCommand extends CalendarQueryCommand {
  isApproved: boolean | undefined = undefined;
  isToBeExport?: boolean = undefined; // for pdf export
  isNoImage?: boolean = undefined; // for no image events
  isLocked?: boolean = undefined; // for locked events
  isAddedToItinerary?: boolean = undefined; // for added to itinerary events
  feedId?: string;
  dmo?: string;
  isManuallyCreated?: boolean = undefined;
  isHubCreated?: boolean = undefined;
  timeOrder?: 'asc' | 'desc' = 'asc'; // for time order
  socialName?: EventSocialName | PlaceSocialName = undefined; // for social name filter;
  isEdited?: boolean = undefined; // for edited places
  rating?: number = undefined;
  price?: string = undefined;
}

export type EventSocialName =
  | 'all'
  | 'facebook'
  | 'google'
  | 'eventbrite'
  | 'manual-hub'
  | 'manual-visitor';

export type PlaceSocialName = 'all' | 'google' | 'manual-hub' | 'manual-visitor';

export const getRequestLimit = () => {
  console.log('window.innerWidth', window.innerWidth);
  return window.innerWidth >= 2560 ? 36 : 16;
};
